'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["options"];
import { forwardRef } from 'react';
import UISelect from 'UIComponents/input/UISelect';
import { jsx as _jsx } from "react/jsx-runtime";
export const ReferenceInputEnumNone = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      options = []
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  if (props.SelectComponent) {
    return /*#__PURE__*/_jsx(props.SelectComponent, Object.assign({}, rest, {
      ref: ref,
      options: options
    }));
  } else {
    return /*#__PURE__*/_jsx(UISelect, Object.assign({}, rest, {
      ref: ref,
      options: options
    }));
  }
});
export default ReferenceInputEnumNone;